module.exports = __webpack_public_path__ + "static/media/smilodonkafa.af588184.png";